import React from "react"

import SchoolTransactions from "./schoolTransactions"

const Admin = () => {
  return <SchoolTransactions />
}
export default Admin
